import { render, staticRenderFns } from "./kamitakuCheckpointRole.vue?vue&type=template&id=2d3ffda3&scoped=true&"
import script from "./kamitakuCheckpointRole.vue?vue&type=script&lang=js&"
export * from "./kamitakuCheckpointRole.vue?vue&type=script&lang=js&"
import style0 from "./kamitakuCheckpointRole.vue?vue&type=style&index=0&id=2d3ffda3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3ffda3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3ffda3')) {
      api.createRecord('2d3ffda3', component.options)
    } else {
      api.reload('2d3ffda3', component.options)
    }
    module.hot.accept("./kamitakuCheckpointRole.vue?vue&type=template&id=2d3ffda3&scoped=true&", function () {
      api.rerender('2d3ffda3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kamitaku/kamitakuCheckpointRole.vue"
export default component.exports